// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
  border: 5px solid #f3f3f3;
  border-top: 5px solid #8f003c;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  animation: spin 0.5s linear infinite;
  align-self: center;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.form-title-header {
  font-family: "Rubik";
  text-decoration: none !important;
  color: rgb(143, 0, 60);
  align-self: center !important;
  text-align: center !important;
  margin-right: 8px !important;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
  padding: 0px !important;
  font-size: 42px;
}

.form-title-sso {
  font-family: "Rubik";
  text-decoration: none !important;
  color: rgb(0, 0, 0);
  align-self: center !important;
  text-align: center !important;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
  font-size: 22px;
}

.container-fluid-loading-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  height: 100vh;
  padding: 15px;
}

.checking {
  font-family: "Rubik";
  align-self: center !important;
  text-align: center !important;
  font-size: 14px;
}

.title-checking-credentials {
  font-weight: 800;
  margin: 0px 0px !important;
  text-align: center;
  display: flex;
  padding: 0px !important;
} /*# sourceMappingURL=CheckingCredentials.css.map */
`, "",{"version":3,"sources":["webpack://./src/components/views/checkingCredentials/CheckingCredentials.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EAEZ,oCAAoC;EACpC,kBAAkB;AACpB;;AAWA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,sBAAsB;EACtB,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;EACnB,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB,EAAE,kDAAkD","sourcesContent":[".loader {\n  border: 5px solid #f3f3f3;\n  border-top: 5px solid #8f003c;\n  border-radius: 50%;\n  width: 35px;\n  height: 35px;\n  -webkit-animation: spin 0.5s linear infinite;\n  animation: spin 0.5s linear infinite;\n  align-self: center;\n}\n\n@-webkit-keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.form-title-header {\n  font-family: \"Rubik\";\n  text-decoration: none !important;\n  color: rgb(143, 0, 60);\n  align-self: center !important;\n  text-align: center !important;\n  margin-right: 8px !important;\n  margin-bottom: 0px !important;\n  margin-top: 0px !important;\n  padding: 0px !important;\n  font-size: 42px;\n}\n\n.form-title-sso {\n  font-family: \"Rubik\";\n  text-decoration: none !important;\n  color: rgb(0, 0, 0);\n  align-self: center !important;\n  text-align: center !important;\n  margin-bottom: 0px !important;\n  margin-top: 0px !important;\n  font-size: 22px;\n}\n\n.container-fluid-loading-page {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  height: 100vh;\n  padding: 15px;\n}\n\n.checking {\n  font-family: \"Rubik\";\n  align-self: center !important;\n  text-align: center !important;\n  font-size: 14px;\n}\n\n.title-checking-credentials {\n  font-weight: 800;\n  margin: 0px 0px !important;\n  text-align: center;\n  display: flex;\n  padding: 0px !important;\n} /*# sourceMappingURL=CheckingCredentials.css.map */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
